import { DialogDescription } from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useProductCategoryStore } from "~/stores/use-product-category-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import ProductCategoryForm from "./product-category-form";

export default function ProductCategoryDialog() {
  const { t } = useTranslation("common");
  const {
    currentProductCategory,
    productCategoryFormOpen,
    isLoading,
    setProductCategoryFormOpen,
    setCurrentProductCategory,
  } = useProductCategoryStore();
  const handleProductCategoryDialog = (open: boolean) => {
    if (open === false) {
      setTimeout(() => {
        setCurrentProductCategory(undefined);
      }, 150);
    }
    setProductCategoryFormOpen(open);
  };
  return (
    <Dialog
      open={productCategoryFormOpen}
      onOpenChange={handleProductCategoryDialog}
    >
      <DialogContent className="max-w-2xl w-full">
        <DialogHeader>
          <DialogTitle>
            {currentProductCategory?.name ??
              t("ProductCategory.new_product_category")}
          </DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <ProductCategoryForm
            productCategory={currentProductCategory}
            onClose={() => handleProductCategoryDialog(false)}
          />
        </div>
        <DialogFooter>
          <Button
            disabled={isLoading}
            type="submit"
            form="product-category-form"
            variant="success"
            className="w-full"
          >
            {currentProductCategory ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
